import {pick} from '@avada/utils';
import {setCartToken} from '@scripttag/helpers/cartTokenStore';

const convertPrice = price => price / 100;

export const prepareCart = cart => {
  if (!cart) return {};
  setCartToken(cart.token);
  return {
    ...pick(cart, ['currency', 'item_count']),
    total_price: convertPrice(cart.total_price),
    items: cart.items.map(el => ({
      ...pick(el, [
        'id',
        'image',
        'sku',
        'quantity',
        'variant_title',
        'product_title',
        'product_id'
      ]),
      price: convertPrice(el.price),
      currency: cart.currency,
      line_price: convertPrice(el.line_price)
    }))
  };
};
